import { Card, CardBody, Col, Table, Button, Container, Row } from "reactstrap";
import TabPlusIcon from "mdi-react/TabPlusIcon";

import { useHistory } from "react-router";
import { decryption } from "../../../HelperFunctions";
import ClearIcon from "@mui/icons-material/Clear";
import BreadCrumb from "../../../../shared/components/BreadCrumb/BreadCrumb";
import { GET_ACTIVE_NOTICE, GET_NOTICE } from "../../../../GraphQL/Queries";
import { useMutation, useQuery } from "@apollo/client";
import Swal from "sweetalert2";
import { DELETE_NOTICE } from "../../../../GraphQL/Mutation";
import { useEffect, useState } from "react";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import JobListTable from "./JobListTable";
const JobPost = () => {
  const history = useHistory();
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const query = permissions?.includes("create_company")
    ? GET_NOTICE
    : GET_ACTIVE_NOTICE;
  const { data, loading, refetch } = useQuery(query);

  //   const [deleteNotice] = useMutation(DELETE_NOTICE, {
  //     onCompleted: (data) => {
  //       if (data.deleteNotice.result_code === "000") {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Deleted",
  //           text: "The notice has been deleted successfully!",
  //         });
  //         refetch(); // Refresh the notice list after deletion
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error",
  //           text: data.deleteNotice.status,
  //         });
  //       }
  //     },
  //     onError: (error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: "System error. Please contact the system admin.",
  //       });
  //       console.error("Error deleting notice:", error);
  //     },
  //   });

  //   const deleteHandler = (id) => {
  //     Swal.fire({
  //       title: "Are you sure?",
  //       text: "You won't be able to revert this!",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes, delete it!",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         deleteNotice({ variables: { id } });
  //       }
  //     });
  //   };
  const [searchTerm, setSearchTerm] = useState("");

  const searchOnchangeHandler = (event) => {
    setSearchTerm(event.target.value);
  };
  let filteredNotices = null;
  // Filter notices based on the search term
  if (permissions?.includes("create_company")) {
    filteredNotices = data?.getNotice?.filter((notice) =>
      notice.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  } else {
    filteredNotices = data?.getActiveNotice?.filter((notice) =>
      notice.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  const [selectedUserType, setSelectedUserType] = useState("null");
  const handleUserTypeChange = (event) => {};
  const handleFilterReset = () => {};

  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "JobPost List ",
    },
  ];
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <BreadCrumb breadCrumbData={breadCrumbData} />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">JobPost List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {permissions?.includes("create_company") && (
                <Button
                  onClick={() => history.push("/job_post/new")}
                  color="primary"
                >
                  <TabPlusIcon className="mr-1" />
                  Create JobPost
                </Button>
              )}
            </Col>
          </Row>
          {/* <Row className="mb-3">
            <Col md={3} xs={12}>
              <div className="inbox__emails-control-search mr-0">
                <input
                  className="w-100"
                  onChange={searchOnchangeHandler}
                  placeholder="Search by Name"
                  value={searchTerm}
                />
                <div className="inbox__emails-control-search-icon">
                  <MagnifyIcon />
                </div>
              </div>
            </Col>
          </Row> */}
          <Row>
            {permissions?.includes("create_company") ? (
              <JobListTable
                loading={loading}
                notices={filteredNotices ? filteredNotices : data?.getNotice}
                // deleteHandler={deleteHandler}
                refetch={refetch}
              ></JobListTable>
            ) : (
              <JobListTable
                loading={loading}
                notices={
                  filteredNotices ? filteredNotices : data?.getActiveNotice
                }
                // deleteHandler={deleteHandler}
                refetch={refetch}
              ></JobListTable>
            )}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JobPost;
